<template>
  <div v-if="isLoading" class="title-bar">
    <b-spinner class="loading-spinner" />
  </div>

  <div v-else class="wynelover-page">
    <section class="hero">
      <div class="hero-copy">
        <h1 class="brand-title">
          <span>WYNE</span>LOVER
        </h1>
        <p class="brand-subtitle">
          {{ translate('the open digital wine ecosystem') }}
        </p>
      </div>
    </section>

    <section class="products">
      <div class="product-grid">
        <article class="product-card" @click="onWyneCellar">
          <img
            :src="require('@/assets/img/wynecellar.png')"
            class="product-image"
            alt="WyneCellar"
          >
          <div class="product-copy">
            <h2><span class="wyne-pink">WYNE</span>CELLAR</h2>
            <h3 class="wyne-grey">{{ translate('your wines. your cellar.') }}</h3>
            <p>
              {{ translate('Manage your personal wine collection,') }}<br>
              {{ translate('purchases, transactions and cellar locations.') }}
            </p>
            <div class="explore">
              {{ translate('Explore WyneCellar') }} <span>→</span>
            </div>
          </div>
        </article>

        <article class="product-card" @click="onWyneTaster">
          <img
            :src="require('@/assets/img/wynetaster.png')"
            class="product-image"
            alt="WyneTaster"
          >
          <div class="product-copy">
            <h2><span class="wyne-green">WYNE</span>TASTER</h2>
            <h3 class="wyne-grey">{{ translate('taste. enjoy. remember.') }}</h3>
            <p>
              {{ translate('Create and manage tasting notes, organise') }}<br>
              {{ translate('tastings and explore wines with structured templates.') }}
            </p>
            <div class="explore">
              {{ translate('Explore WyneTaster') }} <span>→</span>
            </div>
          </div>
        </article>

        <article class="product-card" @click="onWyneMaker">
          <img
            :src="require('@/assets/img/wynemaker.jpg')"
            class="product-image"
            alt="WyneMaker"
          >
          <div class="product-copy">
            <h2><span class="wyne-pink">WYNE</span>MAKER</h2>
            <h3>{{ translate('for wine producers.') }}</h3>
            <p>
              {{ translate('Create your winery page, share your wines') }}<br>
              {{ translate('and connect with wine lovers.') }}
            </p>
            <div class="explore">
              {{ translate('Explore WyneMaker') }} <span>→</span>
            </div>
          </div>
        </article>

        <article class="product-card" @click="onWyneAtlas">
          <img
            :src="require('@/assets/img/wyneatlas.png')"
            class="product-image"
            alt="WyneAtlas"
          >
          <div class="product-copy">
            <h2><span class="wyne-green">WYNE</span>ATLAS</h2>
            <h3>{{ translate('explore wine regions.') }}</h3>
            <p>
              {{ translate('Discover countries, regions and their signature wines.') }}<br>
              {{ translate('A growing guide to the world of wine.') }}
            </p>
            <div class="explore">
              {{ translate('Explore WyneAtlas') }} <span>→</span>
            </div>
          </div>
        </article>
      </div>
    </section>

    <footer class="wynelover-footer">
      <div class="wynelover-footer-content">

        <p class="wynelover-footer-wordmark">
          <span class="wyne">WYNE</span><span class="lover">LOVER</span>
        </p>

        <div class="wynelover-footer-url">
          www.wynelover.com
        </div>

        <div class="wynelover-footer-tagline">
          {{ translate('the open digital wine ecosystem') }}
        </div>

        <div class="wynelover-footer-nav">
          {{ translate('explore') }}
          <span>·</span>
          {{ translate('learn') }}
          <span>·</span>
          {{ translate('taste') }}
          <span>·</span>
          {{ translate('share') }}
        </div>
      </div>
      <div class="wynelover-copyright">
        <p style="text-align:center; margin:0">{{ translate("funware for wine lovers developed and ©copyrighted by N'JOY Information Technology") }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { translate_word } from '../assets/js/translate.js'

export default {
  name: 'IndexDesktop',

  data() {
    return {
      language: 'en',
      isLoading: true
    }
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language
    },

    languages() {
      return [
        { code: 'en', label: 'English', flag: require('@/assets/img/flags/english.png') },
        { code: 'fr', label: 'Français (French)', flag: require('@/assets/img/flags/francais.png') },
        { code: 'de', label: 'Deutsch (German)', flag: require('@/assets/img/flags/deutsch.png') },
        { code: 'es', label: 'Español (Spanish)', flag: require('@/assets/img/flags/spanish.png') },
        { code: 'it', label: 'Italiano (Italian)', flag: require('@/assets/img/flags/italian.png') },
        { code: 'nl', label: 'Nederlands (Dutch)', flag: require('@/assets/img/flags/dutch.png') },
        { code: 'pt', label: 'Português (Portuguese)', flag: require('@/assets/img/flags/portuguese.png') }
      ]
    },

    currentLanguageFlag() {
      const match = this.languages.find((item) => item.code === this.currentLanguage)
      return (match || this.languages[0]).flag
    }
  },

  mounted() {
    let language = Cookies.get('wynelover.language')

    if (!['en', 'fr', 'de', 'es', 'it', 'nl', 'pt'].includes(language)) {
      language = 'en'
    }

    this.selectLanguage(language)
    this.isLoading = false
  },

  methods: {
    selectLanguage(language) {
      this.language = language
      this.$store.commit('setLanguage', language)
      Cookies.set('wynelover.language', language, { expires: 365, path: '/' })
    },

    translate(string) {
      const result = translate_word(string, this.currentLanguage)
      if (string === 'the open digital wine ecosystem') {
        console.log('IndexDesktop:', this.currentLanguage, string, '=>', result)
      }
      return result
    },

    onWyneCellar() {
      window.open('https://www.wynecellar.com', '_blank', 'noopener,noreferrer')
    },

    onWyneTaster() {
      window.open('https://www.wynetaster.com', '_blank', 'noopener,noreferrer')
    },

    onWyneMaker() {
      window.open('https://www.wynemaker.com', '_blank', 'noopener,noreferrer')
    },

    onWyneAtlas() {
      window.location.href = '/atlas/'
    },

    gotoFacebook() {
      window.open('https://www.facebook.com/wynelover.eu', '_blank', 'noopener,noreferrer')
    },

    gotoInstagram() {
      window.open('https://www.instagram.com/wyne.lover/', '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.wynelover-page {
	min-height: 100vh; background: #ffffff;
	color: #555d68;
	font-family: Arial, Helvetica, sans-serif;
}
.wynelover-page * { box-sizing: border-box; }

/* HERO */
.hero {
	position: relative; width: 100vw;
	margin-left: calc(50% - 50vw);
	display: flex; min-height: 330px;
	justify-content: center;
	background-image: url('../assets/img/wynelover.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	text-align: center;
	margin-bottom: 120px;
}
.hero::before {
	content: ""; position: absolute;
	top: 0; left: 0; right: 0;
	height: 100px;
	background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 5%, rgba(255, 255, 255, 0.8) 10%, rgba(255, 255, 255, 0.5) 35%, rgba(255, 255, 255, 0) 100%);
	pointer-events: none;
	z-index: 1;
}
.hero-copy {
	position: relative; z-index: 2;
	padding-top: 100px;
}
.brand-title {
	font-size: clamp(54px, 5vw, 96px) !important;
	color: white !important;
	text-align: center; margin: 0;
	text-shadow: 0 2px 5px rgba(0, 0, 0, 0.35);
}
.brand-title span { color: #6d7a52; font-weight: 700; }
.brand-subtitle {
	font-size: clamp(14px, 2vw, 24px) !important;
	color: rgb(200, 200, 200);
	text-align: center; margin-top: -5px;
	font-weight: bold;
	text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
}

/* PRODUCT TILES */
.products {
	position: relative; z-index: 2;
	padding: 0 40px 48px;
	margin-top: -92px;
	background: #ffffff;
}
.product-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 22px; max-width: 980px;
	margin: 0 auto;
}
.product-card {
	overflow: hidden; background: #ffffff;
	border: 1px solid #ececec;
	border-radius: 6px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
	cursor: pointer;
}
.product-card:hover { box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1); }
.product-image {
	display: block; width: 100%;
	height: 210px;
	object-fit: cover;
}
.product-copy { min-height: 188px; padding: 22px 28px 24px; }
.product-copy h2 {
	margin: 0 0 6px;
	color: #1a1a1a;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 26px; font-weight: 700;
	letter-spacing: 0.04em;
	line-height: 1;
}
.product-copy h3 {
	margin: 0 0 12px;
	color: rgb(112,112,112);
	font-size: 18px;
	font-style: italic; font-weight: 600;
}
.product-copy p {
	margin: 0 0 18px;
	color: #5a6270;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 14px;
	line-height: 1.45;
}
.wyne-green { color: #5f6d42; }
.wyne-pink { color: #c39382; }
.wyne-grey { color: rgb(112,112,112); }
.explore {
	color: rgb(112,112,112);
	font-family: Arial, Helvetica, sans-serif;
	font-size: 14px; font-weight: 700;
}
.explore span { margin-left: 8px; font-size: 16px; font-weight: 400; }

/* WYNELOVER FOOTER */
.wynelover-footer {
	position: relative; width: 100%;
	height: 300px; overflow: hidden;
	color: white;
	background: linear-gradient(to bottom, #ffffff 0%, rgba(255, 255, 255, 0.96) 8%, rgba(255, 255, 255, 0.55) 20%, rgba(255, 255, 255, 0) 38%),
	            linear-gradient(to bottom, #00000000 45%, rgba(0, 0, 0, 0.58) 100%),
	            url('../assets/img/wynelover.jpg') center 48% / cover no-repeat;
}
.wynelover-footer-content {
	position: absolute; left: 0;
	right: 0;
	bottom: 75px;
	text-align: center;
	text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
}
.wynelover-footer-wordmark {
	margin: 0; font-size: 38px;
	line-height: 1;
	letter-spacing: 0.3px;
}
.wynelover-footer-wordmark .wyne { color: #6D7A52; font-weight: 700; }
.wynelover-footer-wordmark .lover { color: white; font-weight: 400; }
.wynelover-footer-url { margin-top: 6px; font-size: 13px; font-weight: 600; }
.wynelover-footer-tagline { margin-top: 4px; font-size: 14px; }
.wynelover-footer-nav {
	margin-top: 10px; font-size: 12px;
	font-weight: 700;
	letter-spacing: 2.2px;
}
.wynelover-footer-nav span { margin: 0 7px; }
.wynelover-copyright {
	position: absolute; left: 0;
	right: 0;
	bottom: 15px;
	margin: 0; padding: 0 10px;
	font-size: 12px; line-height: 16px;
	color: white;
	text-align: center;
	z-index: 3;
}
.wynelover-copyright p { margin: 0; }

/* LOADING */
.title-bar {
	display: flex; height: 100vh;
	align-items: center;
	justify-content: center;
}
.loading-spinner { color: #6d7a52 !important; }

@media (max-width: 980px) {
	.product-grid { max-width: 720px; }
	.brand-title { font-size: 48px; }
}
</style>